import { useEffect, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import axios from "axios";
import { storeTokens, stripTokens } from "@/authClient";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function AuthCallback() {
  const location = useLocation();
  const navigate = useNavigate();
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;
    const sessionId = location.hash.split("session_id=")[1]?.split("&")[0];
    axios
      .post(`${API}/auth/session`, { session_id: sessionId }, { withCredentials: true })
      .then((res) => {
        storeTokens(res.data);
        const user = stripTokens(res.data);
        window.dispatchEvent(new CustomEvent("my-auth-changed", { detail: user }));
        navigate("/", { replace: true, state: { user } });
      })
      .catch(() => {
        navigate("/", { replace: true });
      });
  }, [location, navigate]);

  return (
    <div className="flex min-h-screen items-center justify-center bg-cream">
      <span className="font-serif text-2xl italic text-pine">Monte Yolli…</span>
    </div>
  );
}
